export default "__VITE_ASSET__BMAs2qSL__"